module.exports = __webpack_public_path__ + "img/alpha-x-box.09df0ea0.svg";